import { buildContactsToAPI } from '@/hooks/use-contacts';

/**
 *
 * Criação do objecto de ciente.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados. Assim irá permitir usar esta função
 * na adição e na edição deste modelo.
 *
 * @param {Object}  data
 *
*/
const create = ( data, helpers ) => {
    const { email, phone, mobile } = data;

    const contacts = buildContactsToAPI( [
        { type: 'email', value: email },
        { type: 'phone', value: phone },
        { type: 'mobile', value: mobile }
    ], helpers );

    const client = {
        ...( data.name && { name: data.name }),
        ...( data.website && { website: data.website }),
        ...( data.state && { state: data.state }),
        ...( data.independentCaller && { independent_caller: data.independentCaller }),
        ...( Object.keys( contacts ).length && { ...contacts })
    };

    return client;
};

const requiredFields = [ { field: 'name', isRequiredOnEdit: false } ];

export {
    create,
    requiredFields
};